import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal"

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

      //SPメニューの高さ取得
    function menuHight() {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }

        var $smpHeaderHeight = $('.l-header').height();
        var windowHeight = window.innerHeight;
        var winH = windowHeight - $smpHeaderHeight;

        //動かすターゲットを取得
        var targetSlidebarWrap = $('.c-slidebar-menu'),
            targetSlidebarMenu = $('.c-slidebar__parent'),
            targetSlidebarBtn = $('.c-slidebar-menu__parent');


        //いざ実行(クリックしたら処理を実行する)
        targetSlidebarBtn.on('click', function () {
            $('.c-slidebar-menu').toggleClass('is-active');

        });
    }

      //フッターメニューSPスライド
      function menuSlide() {
          var win = $(window).innerWidth();
          if (win > 950) {
              return false;
          }
          $('.l-footer-normal__menutitle').on('click',function() {
              $(this).toggleClass('is-open');
              $(this).next(".l-footer-normal__menulist.is-sub").slideToggle();
          })
      }

      //owlcarousel
      function owlCarousel() {
          var owls = $('.owl-carousel');
          if (owls.length === 0) {
              return false
          }
          //->スライダー
          owls.imagesLoaded(function () {
              $('.c-main-visual__slider').owlCarousel({
                  items: 1,
                  margin: 0,
                  dots: true,
                  loop: true,
                  nav: false,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<img src="../assets/images/icon-slider-prev.svg" />','<img src="../assets/images/icon-slider-next.svg" />'],
              });
          });
          //->カルーセル
          owls.imagesLoaded(function () {
              $('.c-main-visual__carousel').owlCarousel({
                  items: 1,
                  margin: 16,
                  dots: true,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: false,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      stagePadding: 32,
                    },
                    // breakpoint from 750  up
                    750 : {
                      stagePadding: 64,
                    },
                    // breakpoint from 950 up
                    950 : {
                      stagePadding: 156,
                    },
                    1400 : {
                      stagePadding: 312,
                    }
                  }
              });
          });
          //->カルーセル_ノーマル
          owls.imagesLoaded(function () {
          $('.c-main-visual__carousel.is-normal').owlCarousel({
            items: 1,
            margin: 8,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: false,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
            responsive : {
              // breakpoint from 0 up
              0 : {
                stagePadding: 32,
              },
              // breakpoint from 750  up
              750 : {
                stagePadding: 64,
              },
              // breakpoint from 950 up
              950 : {
                stagePadding: 156,
              },
              1400 : {
                stagePadding: 312,
              }
            }
          });
        });
          //->カルーセル_レイヤー
          owls.imagesLoaded(function () {
            $('.c-main-visual-layer__carousel').owlCarousel({
              items: 1,
              margin: 0,
              dots: true,
              loop: true,
              nav: false,
              autoplayHoverPause: true,
              autoplay: true,
              autoplaySpeed: 500,
              autoWidth: false,
              autoHeight: false,
              center: true,
              navText: ['<img src="..//assets/images/icon-slider-prev.svg" />','<img src="../assets/images/icon-slider-next.svg" />'],
            });
          });
          //->カード_カルーセル
          owls.imagesLoaded(function () {
              $('.js-card-slider').owlCarousel({
                  margin: 0,
                  dots: false,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<img src="../assets/images/icon-slider-prev.svg" />','<img src="../assets/images/icon-slider-next.svg" />'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      items: 1,
                    },
                    // breakpoint from 750 up
                    750 : {
                      items: 3,
                    }
                  }
              });
          });
      }

      function reveal() {
        //- スクロールリーバル
        window.sr = ScrollReveal({duration: 600});
        function domEach(items, callback) {
          if (typeof items === "string") {
            var items = $(items);
          }
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // callback = callback.bind(item)
            callback(i, item);
          }
        }


        sr.reveal(".c-main-visual__image", {scale: 1, opacity:0, duration: 2000,origin:'bottom',distance: '0',}, 100);
        sr.reveal(".c-main-visual__text", {scale: 1, opacity:0, duration: 1000,delay: 600,origin:'left',distance: '50px',easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'}, 100);
        sr.reveal(".l-page-header__title", {delay: 0, scale: 1, duration: 1000, origin: 'bottom', distance: '50px',easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'}, 100);
        sr.reveal(".l-page-header__subtitle", {delay: 200, scale: 1, duration: 1000, origin: 'bottom', distance: '50px',easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'}, 100);
      }

      function initMap() {
        if($('#map').length === 0) {
          return false;
        }

        var map;
        var marker = [];
        var markerData = {};
        var infoWindow = [];
        var name;
        var href;
        var address;
        var lat;
        var lng;

        // 工藤　エンジャパン
        // 担当が　こが　メアド

        map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: 35.5065551, lng: 139.6064224},
          zoom: 9,
        });

        $('#facility table tbody tr:visible').each(function(i, element) {
          name = $(element).find('a').text();
          href = $(element).find('a').attr('href');
          address = $(element).find('a').parent().next().find('span').text();
          lat = $(element).data('lat');
          lng = $(element).data('lng');
          markerData['d' + i] = {name: name, href: href, address: address, lat: lat, lng: lng};
        });

        var len = Object.keys(markerData).length;
        for(var i = 0; i < len; i++) {
          var new_marker = markerData['d' + i];
          lat = new_marker.lat;
          lng = new_marker.lng;

          var markerLatLng = new google.maps.LatLng({ lat, lng }); // 緯度経度のデータ作成
          marker[i] = new google.maps.Marker({ // マーカーの追加
            position: markerLatLng, // マーカーを立てる位置を指定
            map: map // マーカーを立てる地図を指定
          });

          infoWindow[i] = new google.maps.InfoWindow({ // 吹き出しの追加
            content: '<div class="title">' + new_marker.name + '</div><div class="address">' + new_marker.address + '</div><a class="link" href="' + new_marker.href + '" target="_blank">HPはコチラ</a>' // 吹き出しに表示する内容
          });

          markerEvent(i);
        }

        // 吹き出し
        function markerEvent(i) {
          marker[i].addListener('click', function() { // マーカーをクリックしたとき
            infoWindow[i].open(map, marker[i]); // 吹き出しの表示
          });
        }
      }

    function filtering(callback) {
      var checkbox = $('.c-table-block__checkbox input');

      // 表示する時の条件
      function is_visible_judge(data, conditions) {
        var is_visible = true;
        // 表示条件を一つずつチェック
        $.each(conditions, function(key, condition) {
          // 条件に合致しなければ速攻 行を非表示

          if ( data[key] === condition || data[key] === '△' ) {
            is_visible = true;
            return true;
          } else {
            is_visible = false;
            return false;
          }
        });
        // 最後までチェックして全ての条件に合致していれば行を表示する
        return is_visible;
      }
      // テーブルを絞り込む
      function do_filter_table(table, conditions) {
        $(table).find('tr').each(function(index, element) {
          var data = {};
          data.dementia =  $(element).data('dementia');
          data.irou =  $(element).data('irou');
          data.insline =  $(element).data('insline');
          data.baruncartel =  $(element).data('baruncartel');

          if( is_visible_judge(data,conditions) ) {

            console.log($(element));
            $(element).show();
          } else {
            $(element).hide();
          }
        });
        callback();
      }

      // チェックボックスの状態を調べる
      function create_conditions($checkbox){
        var conditions = {};
        // 自分の親に戻って、自分含む子供のINPUTを取得してチェックされていればコンディションに設定
        $checkbox.parent().parent().find("input[type=checkbox]").each(function(index, element){
          if($(element).prop('checked')) {
            conditions[$(this).attr("name")] =  $(this).attr("value");
          }
        });
        return conditions;
      }

      // 処理がキックされるタイミング
      checkbox.each(function(index, element) {
        $(element).on('change', function() {
          var conditions = create_conditions($(this));
          var table = $(this).parent('.c-table-block__checkbox').parent('.c-table-block__checkboxs').next('table').find('tbody');
          do_filter_table(table, conditions);
        });
      });
    }



    $(function() {
        menuSlide();
        owlCarousel();
        reveal();
        initMap();
        filtering(initMap);
    });
  }
}

window.GApp = new App();
